// Faceless scholar portrait (no eyes, nose or mouth) — illustrated asset.
export function ScholarAvatar({ size = 56, className = "", rounded = "9999px" }) {
    return (
        <img
            src="/assets/assistant.webp"
            alt=""
            aria-hidden
            width={size}
            height={size}
            draggable={false}
            className={`object-cover select-none flex-shrink-0 ${className}`}
            style={{ width: size, height: size, borderRadius: rounded, background: "#F4EEDF", boxShadow: "0 0 0 1.5px rgba(201,164,88,0.7)" }}
            data-testid="scholar-avatar"
        />
    );
}
